var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#1e293b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480.07-57.2q-87.39 0-164.46-33.38-77.06-33.38-134.26-90.68-57.19-57.29-90.67-134.41Q57.2-392.79 57.2-480.15q0-87.37 33.37-164.4 33.37-77.04 90.74-134.15 57.38-57.12 134.54-90.73 77.17-33.61 164.58-33.61 87.42 0 164.54 33.47 77.11 33.48 134.12 90.79 57.01 57.31 90.48 134.41 33.47 77.1 33.47 164.5 0 87.39-33.31 164.45-33.32 77.06-90.6 134.2-57.28 57.13-134.52 90.58Q567.37-57.2 480.07-57.2Zm-43.35-78.3v-83.8q-36.52 0-60.53-25.87-24.01-25.87-24.01-62.35v-44.78L143.74-560.8q-5 19.25-7 39.77-2 20.51-2 40.73 0 131.35 85.94 230.93 85.95 99.59 216.04 113.87Zm298.45-110.09q22.57-23.81 39.29-51.42 16.71-27.62 28.19-57.57t17.17-61.71q5.68-31.76 5.68-64.99 0-106.94-58.64-195.1-58.63-88.17-157.53-128.36v17.59q0 36.4-23.94 62.33t-60.91 25.93h-87.76v88.73q0 18.07-13.26 28.71-13.26 10.65-31.57 10.65h-85.02v89.56h263.17q16.19 0 27.74 13.36 11.55 13.37 11.55 29.6v131.17h43.15q29.17 0 51.91 17.16 22.74 17.16 30.78 44.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/country.112760523f47fe6893e6bc2103e4bb24.svg";
export { ForwardRef as ReactComponent };